"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Box = _interopRequireDefault(require("../Box"));

var _RadioContext = require("./context/RadioContext");

var _RadioButton = _interopRequireDefault(require("./RadioButton.sizes"));

var _styles = require("./styles");

var _excluded = ["id", "name", "className", "colorLabel", "disabled", "label", "labelFontSize", "size", "value", "style", "theme", "onChange"];
var RadioButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _radioButtonThemeSize;

  var id = _ref.id,
      name = _ref.name,
      className = _ref.className,
      colorLabel = _ref.colorLabel,
      disabled = _ref.disabled,
      label = _ref.label,
      labelFontSize = _ref.labelFontSize,
      size = _ref.size,
      value = _ref.value,
      style = _ref.style,
      theme = _ref.theme,
      _onChange = _ref.onChange,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useRadio = (0, _RadioContext.useRadio)(),
      radioChecked = _useRadio.radioChecked,
      setRadioChecked = _useRadio.setRadioChecked;

  var radioId = id;
  var radioButtonThemeSizes = (0, _RadioButton.default)(theme);
  var radioButtonSize = (_radioButtonThemeSize = radioButtonThemeSizes[size]) !== null && _radioButtonThemeSize !== void 0 ? _radioButtonThemeSize : radioButtonThemeSizes[theme.sizes.input];
  var color = theme.colors[colorLabel] || theme.colors.textDefault;
  var fieldClassNames = [];

  if (value === radioChecked) {
    fieldClassNames.push("checked");
  }

  if (disabled) {
    fieldClassNames.push("disabled");
  }

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    paddingType: "square",
    paddingSize: "none",
    style: style,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_styles.Label, {
    htmlFor: radioId,
    typography: radioButtonSize.label,
    labelFontSize: labelFontSize,
    color: color
  }, /*#__PURE__*/_react.default.createElement(_styles.RadioButtonStyled, {
    className: fieldClassNames.join(' ')
  }), /*#__PURE__*/_react.default.createElement(_styles.RadioButtonHidden, Object.assign({
    disabled: disabled,
    id: radioId,
    name: name,
    ref: ref,
    type: "radio",
    value: value,
    onChange: function onChange(e) {
      setRadioChecked(e.target.value);
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(e);
    }
  }, rest)), label));
});

var _default = (0, _styledComponents.withTheme)(RadioButton);

exports.default = _default;